var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingLine',{attrs:{"title":"Danh sách đang được tổng kết","count":_vm.period.progress}})}
var staticRenderFns = []

export { render, staticRenderFns }